// extracted by mini-css-extract-plugin
module.exports = {"linkButton":"LoginSection_linkButton__3yuLG","linkButtonWrapper":"LoginSection_linkButtonWrapper__fwVqQ"};